import { Box, Button, Link, Typography } from '@mui/material';
import DefaultLayout from 'src/layouts/DefaultLayout';
import GlobalHeader from 'src/components/GlobalHeader';

const DOCS_DEV_URL = 'http://localhost:5173/docs/';

/**
 * Shown when the user navigates to /docs or /docs/* in the React app.
 * In production, /docs is served as static files so this route is rarely hit;
 * in development, the docs are served by VitePress on a different port, so we
 * show instructions and a link.
 */
export default function DocsScreen() {
    const isDev = process.env.NODE_ENV === 'development';

    return (
        <DefaultLayout>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    flexGrow: 1,
                    overflowY: 'auto',
                    width: '100%',
                    height: '100%',
                    boxSizing: 'border-box',
                    alignItems: 'center',
                    justifyContent: 'center',
                    p: 3,
                }}
            >
                <GlobalHeader title="Docs" />
                <Box sx={{ maxWidth: 400, textAlign: 'center' }}>
                    {isDev ? (
                        <>
                            <Typography variant="body1" sx={{ mb: 2 }}>
                                Documentation is served by VitePress. Run in the repo root:
                            </Typography>
                            <Typography
                                component="code"
                                sx={{
                                    display: 'block',
                                    p: 2,
                                    bgcolor: 'action.hover',
                                    borderRadius: 1,
                                    fontFamily: 'monospace',
                                    fontSize: '0.875rem',
                                    mb: 2,
                                }}
                            >
                                yarn docs:dev
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                                Then open the docs URL (default port 5173).
                            </Typography>
                            <Button component={Link} href={DOCS_DEV_URL} target="_blank" rel="noopener noreferrer" variant="contained">
                                Open docs
                            </Button>
                        </>
                    ) : (
                        <>
                            <Typography variant="body1" sx={{ mb: 2 }}>
                                Opening documentation…
                            </Typography>
                            <Button component={Link} href="/docs/" variant="contained">
                                Go to docs
                            </Button>
                        </>
                    )}
                </Box>
            </Box>
        </DefaultLayout>
    );
}
